import { render, staticRenderFns } from "./simulador-ampliar-tabela.vue?vue&type=template&id=49b3ed94&"
import script from "./simulador-ampliar-tabela.vue?vue&type=script&lang=js&"
export * from "./simulador-ampliar-tabela.vue?vue&type=script&lang=js&"
import style0 from "./simulador-ampliar-tabela.vue?vue&type=style&index=0&lang=sass&scope=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VDataTable,VSpacer,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49b3ed94')) {
      api.createRecord('49b3ed94', component.options)
    } else {
      api.reload('49b3ed94', component.options)
    }
    module.hot.accept("./simulador-ampliar-tabela.vue?vue&type=template&id=49b3ed94&", function () {
      api.rerender('49b3ed94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modal/simulador-ampliar-tabela.vue"
export default component.exports